import React from 'react'
import Lpntable from './Components/Lpn-table'
import Header from '../../../Components/Header'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SalesInvoice = () => {
   const location = useLocation();
   console.log("clg clgl cg ",location);
  return (
        <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
        <Helmet>
				    <title>Sales Invoice List</title>
			  </Helmet>
        <Header />
        <Lpntable />
    </div>
  )
}

export default SalesInvoice